<template>
<v-container >
		<v-layout column wrap align-center><v-flex xs12 sm6>
			<v-btn small @click="getWorkstatus()">更新</v-btn>
		</v-flex></v-layout>
		<v-data-table light :items="workstatus" item-key="day" :headers="headers" :rows-per-page-items="maxItems">
			<template v-slot:items="props">
			<td>{{ props.item.name }}</td>
			<td>{{ props.item.sipno }}</td>
			<td><v-btn :href="'callto:' + props.item.sipno" :disabled="props.item.ip == null">接続</v-btn></td>
			<td>{{ props.item.place }}</td>
			</template>
		</v-data-table>
</v-container>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import axios from 'axios';
// locale="japan" event-start="startDate" event-end="startDate" event-name="name"
  export default {
    computed: {
    },
    data: function() {
		return {
			workstatus: [],
			maxItems: [-1],
			headers: [
				{ text: '名前', value: 'name', sortable: false },
				{ text: 'SIP', value: 'sipno' , sortable: false},
				{ text: '勤務場所', value: 'place' , sortable: false},
				{ text: '状態', value: 'status' , sortable: false},
			],
        };
    },
    mounted: function() {
	},
	watch: {
	},
	methods: {
		initDisp: function() {
	    	var now = new Date();
	    	this.currentDate = now;
			this.getWorkstatus();
			setInterval(this.getWorkstatus, 60000);
		},
		getWorkstatus: function() {
			axios.get("api_workstatus", {
				params: {
				}
			}).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
			        this.workstatus = appResp.data;
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
		},
	},
  }
</script>

<style scoped>
</style>

